import { createContext, type PropsWithChildren, useContext } from 'react';

import { type AssortmentTableNames } from '../../storage/session-storage';

const AssortmentTableContext = createContext<AssortmentTableNames | null>(null);

interface AssortmentTableContextProviderProps extends PropsWithChildren {
  table: AssortmentTableNames;
}

export const AssortmentTableContextProvider = ({
  children,
  table,
}: AssortmentTableContextProviderProps) => {
  return (
    <AssortmentTableContext.Provider value={table}>
      {children}
    </AssortmentTableContext.Provider>
  );
};

export const useAssortmentTableContext = () => {
  const context = useContext(AssortmentTableContext);
  if (context === null) {
    throw new Error(
      '`useAssortmentTableContext` must be used within an `<AssortmentTableContextProvider />`',
    );
  }
  return context;
};
